import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import AlertsView from './AlertsView'
import * as AlertActionCreators from '../../actions/alert'
import * as TimeseriesActionCreators from '../../actions/timeseries'

class UnitAlertsContainer extends React.Component {
  static propTypes = {
    unitId: PropTypes.number.isRequired,
    timeseries: PropTypes.object.isRequired,
    alertsByUnit: PropTypes.object.isRequired,
    alerts: PropTypes.object.isRequired,
    alertActions: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      alertsByUnit: state.alertsByUnit,
      alerts: state.alerts,
      timeseries: state.timeseries,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      alertActions: bindActionCreators(AlertActionCreators, dispatch),
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const {
      unitId, alertActions,
    } = this.props
    alertActions.listAlertsByUnit(unitId)
  }

  componentDidUpdate() {
    const {
      timeseriesActions,
    } = this.props
    this.alerts().forEach((alert) => {
      timeseriesActions.fetchTimeseries(alert.timeseries_id)
    })
  }

  alertLink = (alert) => {
    const { timeseries } = this.props
    const ts = timeseries[alert.timeseries_id]
    let link = ''
    if (ts) {
      link = `/units/${ts.unit_id}/timeseries/${ts.id}`
    }
    return link
  }

  alerts() {
    const { unitId, alertsByUnit, alerts } = this.props
    const alertIds = alertsByUnit[unitId] || []
    const unitAlerts = []
    alertIds.forEach((alertId) => {
      const alert = alerts[alertId]
      if (alert && alert.timeseries_id !== 0) {
        unitAlerts.push(alert)
      }
    })
    return unitAlerts
  }

  render() {
    const {
      timeseries,
    } = this.props
    const alerts = this.alerts()
    return (
      <AlertsView alerts={alerts} timeseries={timeseries} alertLink={this.alertLink} />
    )
  }
}

export default connect(
  UnitAlertsContainer.mapStateToProps,
  UnitAlertsContainer.mapDispatchToProps,
)(UnitAlertsContainer)
